import React from 'react';
import { AutocompleteInput } from './AutocompleteInput';
import { Option } from './Option';

type Props = {
  name: string;
  label: string;
  options: Option[] | undefined;
  loading?: boolean;
  required?: boolean;
  disabled?: boolean;
  validate?: (value: string | undefined) => boolean | string;
  dataTestId?: string;
};

export const SelectInput: React.FC<Props> = ({
  name,
  label,
  options,
  loading,
  required,
  disabled,
  validate,
  dataTestId,
}) => {
  return (
    <AutocompleteInput
      name={name}
      label={label}
      options={options}
      loading={loading}
      required={required}
      disabled={disabled}
      selectOnly={true}
      validate={validate}
      dataTestId={dataTestId}
    />
  );
};
